import * as React from "react";
import { makeStyles, Typography } from "@material-ui/core";

import { ShareUrlButton } from "./ShareUrlButton";

const useStyles = makeStyles(theme => ({
  description: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
}));

interface Props {
  valuationId: number;
  userId: number;
}

export const ShareModal: React.FC<Props> = ({ valuationId, userId }) => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.description}>
        Give a friend access to the Know Your Worth app.
      </Typography>
      <ShareUrlButton valuationId={valuationId} userId={userId} />
    </>
  );
};
